export const LOADER_IMAGE = 'penguin_session_loader.svg';
export const LOADER_ALT_TEXT = 'Loading';
